<template>
    <b-navbar class="main-navigation" toggleable="lg" type="dark" :sticky="true">
      <b-navbar-brand :to=" {name: 'home'}">FairVote</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :to="{ name: 'liste', params: {type: 'liste'}}">Abstimmungen</b-nav-item>
          <b-nav-item :to="{name: 'evoting'}">Was ist E-Voting</b-nav-item>
          <b-nav-item :to="{name: 'help'}">Hilfe</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="!this.$store.state.loggedIn" :to="{name: 'login'}">Anmelden</b-nav-item>
          <b-nav-item-dropdown right v-else>
            <template slot="button-content"><em>{{ this.$store.state.user.name }}</em></template>
            <b-dropdown-item  :to="{name: 'profil'}">Profil</b-dropdown-item>
            <b-dropdown-item v-if="this.$store.state.user.isAdmin" :to="{name: 'proposalList'}">Admin</b-dropdown-item>
            <b-dropdown-item  @click="logout">Abmelden</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
</template>
<script>
export default {
  name: 'Navigation',
  data() {
    return {

    };
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
  },
};
</script>
<style>
.main-navigation{
  background-color: rgb(228,23,23);
}

</style>
